import { createAction, props } from '@ngrx/store'; 

export const loadPermissions = createAction('[Permission] Load');

export const loadPermissionsSuccess = createAction(
  '[Permission] Load Success',
  props<{ response: Array<{code: string}> | null }>()
);

export const loadPermissionsFailure = createAction(
  '[Permission] Load Failure',
  props<{ error: string }>()
);

export const clearPermissions = createAction('[Permission] Clear');
 
export const setPermissions = createAction(
  '[Permission] Set Permissions',
  props<{ data: any }>()  
);
